import { render, staticRenderFns } from "./indExtra.vue?vue&type=template&id=5343a4ee"
import script from "./indExtra.vue?vue&type=script&lang=ts"
export * from "./indExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports